<template>
  <div class="pageFooter">
    <div class="positionFooter"><p>©2019 深圳市百运科技有限公司 版权所有 <a target="_blank" href="https://beian.miit.gov.cn/">粤ICP备14023066号-1</a></p></div>
  </div>
</template>
<script>
  export default {
    props: {

    },
    data () {
      return {

      }
    },
    methods:{}
  }
</script>
<style lang="css" scoped>
  .pageFooter{position:absolute;bottom:10px;text-align:center;width:100%;}

  /*.pageFooter{position:relative;margin:35px 0 10px 0;}*/
  .positionFooter{text-align:center;margin:auto;width:100%;}
  .pageFooter p{color:#999;font-size:13px;line-height:22px;text-align:center}
  .pageFooter p a{color:#0C5ee4;font-size:13px;line-height:22px;}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/public/menberFooterInfo.vue